var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e/icon/contact/comment_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6673 6.66699C13.7719 6.66699 14.6673 7.56239 14.6673 8.66699V10.667C14.6673 11.7716 13.7719 12.667 12.6673 12.667V13.3111C12.6673 14.0177 11.8433 14.4037 11.3005 13.9513L9.75925 12.667H8.00065C6.89605 12.667 6.00065 11.7716 6.00065 10.667V8.66699C6.00065 7.56239 6.89605 6.66699 8.00065 6.66699H12.6673ZM10.6673 2.66699C11.7719 2.66699 12.6673 3.56243 12.6673 4.66699V5.33366H7.33398C5.86122 5.33366 4.66732 6.52757 4.66732 8.00033V10.667C4.66732 11.3633 4.93423 11.9974 5.37133 12.4723L4.66732 13.0003C4.11796 13.4123 3.33398 13.0204 3.33398 12.3337V11.3337C2.22942 11.3337 1.33398 10.4383 1.33398 9.33366V4.66699C1.33398 3.56243 2.22942 2.66699 3.33398 2.66699H10.6673Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentFill);
export default __webpack_public_path__ + "static/media/comment_fill.4f0f87211dd1be32651587144b759345.svg";
export { ForwardRef as ReactComponent };